"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.awaitUploads = awaitUploads;
var _progressPromise = require("@prezly/progress-promise");
var _lodash = _interopRequireDefault(require("lodash.clamp"));
var _toProgressPromise = require("./toProgressPromise.cjs");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var MIN_PROGRESS = 0;
var MAX_PROGRESS = 100;
function awaitUploads(promises) {
  var result = {
    failedUploads: [],
    successfulUploads: []
  };
  if (promises.length === 0) {
    return new _progressPromise.ProgressPromise(function (resolve) {
      return resolve(result);
    });
  }
  var progressBuffer = new Array(promises.length).fill(MIN_PROGRESS);
  var resolvedCount = 0;
  return new _progressPromise.ProgressPromise(function (resolve, _, reportProgress) {
    function notifyProgress() {
      var sumProgress = progressBuffer.reduce(function (sum, subProgress) {
        return sum + subProgress;
      }, 0);
      reportProgress(sumProgress / promises.length);
    }
    function resolveSubPromise(index) {
      progressBuffer[index] = MAX_PROGRESS;
      resolvedCount += 1;
      if (resolvedCount === promises.length) {
        resolve(result);
      } else {
        notifyProgress();
      }
    }
    promises.forEach(function (promise, index) {
      (0, _toProgressPromise.toProgressPromise)(promise).then(function (subResult) {
        result.successfulUploads.push(subResult);
        resolveSubPromise(index);
      }, function (subError) {
        result.failedUploads.push(subError);
        resolveSubPromise(index);
      }, function (subProgress) {
        progressBuffer[index] = (0, _lodash["default"])(subProgress, progressBuffer[index], MAX_PROGRESS);
        notifyProgress();
      });
    });
  });
}